import CONTRATO_VIDEOS from '@/graphql/querys/administracion/contratos/contrato/contratovideos/contratoVideos.gql';
import AGREGAR_CONTRATO_VIDEO from '@/graphql/mutations/administracion/contratos/contrato/contratovideos/agregarContratoVideo.gql';
import ACTUALIZAR_CONTRATO_VIDEO from '@/graphql/mutations/administracion/contratos/contrato/contratovideos/actualizarContratoVideo.gql';
import REMOVER_CONTRATO_VIDEO from '@/graphql/mutations/administracion/contratos/contrato/contratovideos/removerContratoVideo.gql';

export default {
  methods: {
    // Agregar Contrato Video
    async mixAgregarContratoVideo() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_VIDEO,
          variables: {
            video: this.video,
          },
          update: (store, { data: { agregarContratoVideo } }) => {
            const query = {
              query: CONTRATO_VIDEOS,
              variables: {
                idContrato: this.idContrato,
              },
            };
            const { contratoVideos } = store.readQuery(query);
            const contratoVideosCopia = contratoVideos.slice();
            contratoVideosCopia.push(agregarContratoVideo);
            store.writeQuery({
              ...query,
              data: {
                contratoVideos: contratoVideosCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Actualizar Contrato Video
    async mixActualizarContratoVideo() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_VIDEO,
          variables: {
            id: this.contratoVideoEditar.id,
            video: this.video,
          },
          update: (store, { data: { actualizarContratoVideo } }) => {
            const query = {
              query: CONTRATO_VIDEOS,
              variables: {
                idContrato: this.contratoVideoEditar.idContrato,
              },
            };
            const data = store.readQuery(query);
            const { contratoVideos } = data;
            const index = contratoVideos
              .findIndex((contratoVideo) => contratoVideo.id
                  === actualizarContratoVideo.id);
            if (index !== -1) {
              contratoVideos.splice(index, 1, actualizarContratoVideo);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Contrato Video
    async mixEliminarContratoVideo() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_VIDEO,
        variables: {
          id: this.contratoVideoEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_VIDEOS,
            variables: {
              idContrato: this.contratoVideoEliminar.idContrato,
            },
          };
          const data = store.readQuery(query);
          const { contratoVideos } = data;
          const index = contratoVideos
            .findIndex((contratoVideo) => contratoVideo.id === this.contratoVideoEliminar.id);
          if (index !== -1) {
            contratoVideos.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
  computed: {
    mixValidarUrl() {
      if (!this.video.url) return true;
      const url = this.video.url.split(
        /(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/,
      );
      const YId = undefined !== url[2] ? url[2].split(/[^0-9a-z_/\\-]/i)[0] : url[0];
      if (YId === url[0]) {
        return false;
      }
      return true;
    },
  },
};
